import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';

document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('.embla');
  carousels.forEach((carousel) => {

	    const plugins = [
      Autoplay({ delay: 3000, stopOnInteraction: false })
    ];

    const embla = EmblaCarousel(carousel, {
      loop: true, // or false if you don't want infinite looping
    },plugins);
	console.log('embla initialized', embla);
  });
});

